import React, { useState, useEffect } from 'react';
import { Menu, X, Instagram } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[var(--z-fixed)] transition-all duration-300 ${
        isScrolled ? 'glass-effect border-b border-gray-800' : 'bg-transparent'
      }`}
      style={{ padding: '1.5rem 0' }}
    >
      <div className="container-artworld">
        <div className="flex-between">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="hero-title"
            style={{
              fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
              background: 'linear-gradient(135deg, #ffffff 0%, #c0c0c0 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              cursor: 'pointer',
              border: 'none',
              background: 'none',
              padding: 0
            }}
          >
            W SHOOT
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="label-text hover:text-white transition-colors duration-300"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              À Propos
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="label-text hover:text-white transition-colors duration-300"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="label-text hover:text-white transition-colors duration-300"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="label-text hover:text-white transition-colors duration-300"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Partenaires
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="label-text hover:text-white transition-colors duration-300"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Contact
            </button>
            <a
              href="https://www.instagram.com/w_shoot_22/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors duration-300"
            >
              <Instagram size={20} />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white"
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav
            className="md:hidden flex flex-col gap-6 mt-8 pb-6 border-t border-gray-800 pt-6 animate-fade-in"
            style={{ animation: 'fadeInUp 0.3s ease-out' }}
          >
            <button
              onClick={() => scrollToSection('about')}
              className="label-text hover:text-white transition-colors duration-300 text-left"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              À Propos
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="label-text hover:text-white transition-colors duration-300 text-left"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="label-text hover:text-white transition-colors duration-300 text-left"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="label-text hover:text-white transition-colors duration-300 text-left"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Partenaires
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="label-text hover:text-white transition-colors duration-300 text-left"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Contact
            </button>
            <a
              href="https://www.instagram.com/w_shoot_22/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors duration-300"
            >
              <Instagram size={20} />
              <span className="label-text">@w_shoot_22</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
